import { Component, Inject, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { track } from '../../../analytics';

@Component({
    templateUrl: './unauthorized.html',
    styleUrls: ['./unauthorized.scss']
})
export class UnauthorizedView {

    constructor(
        public auth: OidcSecurityService,
		private router: Router
    ) {

    }


    login() {
        track('User Started Login');
        this.auth.authorize();
    }

	ngOnInit() {
		// Temporary hack till we fix the user-data endpoints
		setTimeout(
			() => {
				this.router.navigate(["/"]);
			},
			100
		)
	}

}
